@switch (variant()) {
    @case ('small') {
        <div class="cssload-loader" [title]="title()">
            <div class="cssload-flipper">
                <div class="cssload-front"></div>
                <div class="cssload-back"></div>
            </div>
        </div>
    }
    @default {
    <div class="floatBarsGContainer" [title]="title()">
        <div class="floatBarsG floatBarsG_1"></div>
        <div class="floatBarsG floatBarsG_2"></div>
        <div class="floatBarsG floatBarsG_3"></div>
        <div class="floatBarsG floatBarsG_4"></div>
        <div class="floatBarsG floatBarsG_5"></div>
        <div class="floatBarsG floatBarsG_6"></div>
        <div class="floatBarsG floatBarsG_7"></div>
        <div class="floatBarsG floatBarsG_8"></div>
    </div>
    }
}
